//===----------------------------------------------------------------------===//
//
//  Copyright 2024-2026 Trovares Inc. dba Rocketgraph.  All rights reserved.
//
//===----------------------------------------------------------------------===//

import { QueryCache, QueryClient } from '@tanstack/react-query';
import LoginRequiredException from '@/utils/LoginRequiredException';

// Auth-error handler registered from inside React (AuthProvider), where
// useTheme's handleLogout and the router are available.  The QueryCache
// onError below cannot use hooks, so it delegates to this.
let authErrorHandler: () => void = () => {};
export const registerQueryAuthErrorHandler = (fn: () => void) => {
  authErrorHandler = fn;
};

// Shared across the app.  Defaults: no auto-retry; refetch on window focus is
// on so config/datasets pick up external changes when the user returns to the
// tab (per-query staleTime keeps that from being trigger-happy).  A 401
// (LoginRequiredException) on any query routes through the registered handler
// to log out and redirect — authService has already cleared auth by then.
export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error) => {
      if (error instanceof LoginRequiredException)
        authErrorHandler();
    },
  }),
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: true,
    },
  },
});
